export enum IReactionsMenuParent {
    Button = 1,
    OverflowMenu = 2,
    OverflowDrawer = 3
}
